import React from "react";
import { Badge, Row, Col, Button, List } from "antd";
import { useNavigate } from "react-router-dom";
import { SendOutlined } from "@ant-design/icons";
import { App } from "context/AppContext";

const TxnBoard = ({ data }) => {
  const navigate = useNavigate();
  const { darkMode } = App();

  return (
    <Row gutter={[16, 16]}>
      <Col xl={12} xs={24}>
        <Badge.Ribbon text="">
          <List
            size="small"
            bordered
            dataSource={data[0]}
            header={<div style={{ fontWeight: 500 }}>Санхүүгийн гүйлгээ</div>}
            renderItem={(item, i) => (
              <List.Item
                onClick={() => navigate(item.endpoint)}
                extra={<Button type="link" shape="circle" size="small" icon={<SendOutlined />} />}
                style={{ color: "#1890ff" }}
                className={darkMode ? "list-item-dark" : "list-item"}
              >
                {`${item.title}`}
              </List.Item>
            )}
          />
        </Badge.Ribbon>
      </Col>

      <Col xl={12} xs={24}>
        <Badge.Ribbon text="">
          <List
            size="small"
            bordered
            dataSource={data[1]}
            header={<div>Санхүүгийн бус гүйлгээ</div>}
            renderItem={(item, i) => {
              return (
                <List.Item
                  onClick={() => navigate(item.endpoint)}
                  extra={<Button type="link" shape="circle" size="small" icon={<SendOutlined />} />}
                  style={{ color: "#1890ff" }}
                  className={darkMode ? "list-item-dark" : "list-item"}
                >
                  {`${item.title}`}
                </List.Item>
              );
            }}
          />
        </Badge.Ribbon>
      </Col>
    </Row>
  );
};

export default TxnBoard;
